import { FormGroup, FormControl } from '@angular/forms';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/filter';

import { QueryParams } from '../grid/grid-params';
import { Filter } from './filter.class';

class Options {
  constructor(
    public debounceTime: number = 0,
    public minLength: number = 0
  ) { }
}

export class InputFilter extends Filter {

  private control: FormControl = null;

  constructor(
    filterName: string,
    private options: Options = new Options(),
    defaultValue: any = null
  ) {
    super(filterName, defaultValue);
  }

  public getFormElement(): FormGroup | FormControl {
    this.control = new FormControl();
    this.control.setValue(this.getValue());
    this.setListeners();

    return this.control;
  }

  public updateValue() {
    let value: string = this.getFilterCriteria(this.filterName);
    this.control.setValue(value);
  }

  public clearValue() {
    this.control.setValue(null);
  }

  private setListeners() {
    this.control.valueChanges
    .debounceTime(this.options.debounceTime)
    .filter(value => value !== this.getFilterCriteria(this.filterName))
    .map((value: string) => this.isFilterValueValid(value) ? value : '' )
    .subscribe((value: string) => {
      value = value || undefined;

      this.onChange.emit(value);
      this.setFilterCriteria(this.filterName, value);
    });
  }

  private isFilterValueValid(value: string): boolean {
    return (
        value !== null &&
        value.length > this.options.minLength
      );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/shared/filter-form/input-filter.ts